import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("hafani_admin_token")}`,
});

export const adminLogout = (navigate) => {
  localStorage.removeItem("hafani_admin_token");
  localStorage.removeItem("hafani_admin_role");
  navigate("/admin/login");
};

// Retourne un handler : true si l'erreur était une 401/403 (et a déclenché le logout)
export const useAdminAuthError = () => {
  const navigate = useNavigate();
  return useCallback(
    (err) => {
      if (err.response?.status === 401 || err.response?.status === 403) {
        adminLogout(navigate);
        return true;
      }
      return false;
    },
    [navigate]
  );
};
